import { APP_BASE_NAME, APP_DISPLAY_NAME, APP_STAGE_LABEL } from "../../branding";
import { cn } from "../../lib/utils";

type ForgeWordmarkProps = {
  readonly showStageBadge?: boolean;
  /** Keeps the logotype legible when the wordmark sits on dark artwork. */
  readonly tone?: "default" | "on-dark";
  /** Slightly larger mark + type for auth cards (pairing / login). */
  readonly variant?: "default" | "auth";
};

/**
 * Product wordmark: Forge “F” mark + Forge logotype. Optional stage pill (login / pairing).
 */
export function ForgeWordmark({
  showStageBadge = false,
  tone = "default",
  variant = "default",
}: ForgeWordmarkProps) {
  const isAuth = variant === "auth";
  const markSize = isAuth ? 20 : 16;
  const forgeMarkImg = (
    <img
      className={isAuth ? "h-5 w-5 shrink-0" : "h-4 w-4 shrink-0"}
      src="/forge-mark.svg"
      width={markSize}
      height={markSize}
      alt=""
      aria-hidden="true"
    />
  );
  const name = (
    <span
      className={cn(
        "truncate font-semibold tracking-tight",
        isAuth ? "text-[15px] sm:text-base" : "text-sm",
        tone === "on-dark" ? "text-primary-foreground" : "text-foreground",
      )}
    >
      {APP_BASE_NAME}
    </span>
  );
  const stagePill = (
    <span
      className={
        isAuth
          ? "rounded-full bg-muted/50 px-2 py-0.5 text-[9px] leading-none font-medium tracking-[0.14em] text-muted-foreground/70 uppercase [text-indent:0.14em]"
          : "rounded-full bg-muted/50 px-1.5 py-0.5 text-[8px] leading-none font-medium tracking-[0.18em] text-muted-foreground/60 uppercase [text-indent:0.18em]"
      }
    >
      {APP_STAGE_LABEL}
    </span>
  );

  if (showStageBadge) {
    return (
      <div className="flex items-center gap-1.5 rounded-md" aria-label={APP_DISPLAY_NAME}>
        <span className="flex items-center gap-2">
          {forgeMarkImg}
          {name}
        </span>
        {stagePill}
      </div>
    );
  }

  return (
    <span className="flex min-w-0 items-center gap-1.5" aria-label={APP_DISPLAY_NAME}>
      {forgeMarkImg}
      {name}
    </span>
  );
}
